/**
 * NutrientDeficiencyPage.tsx
 * Page component for the Nutrient Deficiency Calculator
 */

import React from 'react';
import { Container, Typography, Box, Breadcrumbs } from '@mui/material';
import NutrientDeficiencyCalculator from '../components/nutrient-deficiency/NutrientDeficiencyCalculator';
import { Link } from 'react-router-dom';

const NutrientDeficiencyPage: React.FC = () => {
  return (
    <Container maxWidth="xl">
      <Box sx={{ py: 4 }}>
        <Breadcrumbs sx={{ mb: 2 }}>
          <Link to="/">Home</Link>
          <Typography color="text.primary">Nutrient Deficiency</Typography>
        </Breadcrumbs>
        
        <Typography variant="h4" component="h1" gutterBottom>
          Nutrient Deficiency Calculator
        </Typography>
        
        <Typography variant="body1" paragraph>
          Identify and diagnose nutrient deficiencies and imbalances in your hydroponic system.
          Enter your current nutrient levels to receive detailed analysis and treatment recommendations.
        </Typography>
        
        <NutrientDeficiencyCalculator />
      </Box>
    </Container>
  );
};

export default NutrientDeficiencyPage;
